export default __webpack_public_path__ + "static/media/uploadIcon.7b56f720.svg";